const LaunchPage = ({  }) => {
  const keyframes = `
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
`;
  const styleSheets = Array.from(document.styleSheets).filter(
    (styleSheet) =>
      !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
  );
  for (let style of styleSheets) {
    if (style instanceof CSSStyleSheet && style.cssRules) {
      style.insertRule(keyframes, style.cssRules.length);
    }
  }
  const loaderStyle = () => ({
    marginTop: '50vh',
    marginLeft: '50vw',
    border: '12px solid #F3F3F3',
    borderRadius: '50%',
    borderTop: '12px solid grey',
    width: '40px',
    height: '40px',
    animationName: 'spin',
    animationDuration: '2s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  });

  return (
    <div id="os1-consoleui-settings-loader" style={{width:'100vw', height:'100vh'}}>
        <div style={loaderStyle()}></div>
      </div>
  );
};

export default LaunchPage;
